const About = () => {
    return (
        <div className="historia">
                <p className="historia-text">
                    Musashi nace como una escuela dedicada al desarrollo del Jiu-Jitsu y el grappling, donde la disciplina, la técnica y la constancia son la base del aprendizaje. Creemos que el progreso en el tatami se construye a través de la práctica diaria, la repetición y el compromiso con mejorar en cada entrenamiento.
                </p>

                <p className="historia-text">
                    Más que una academia, Musashi es una comunidad donde alumnos y profesores crecen juntos. Cada entrenamiento representa una oportunidad para aprender, desafiarse y desarrollar habilidades técnicas, manteniendo siempre el respeto y la colaboración entre compañeros.
                </p>

                <p className="historia-text">
                    Nuestra visión es formar practicantes que no solo mejoren dentro del tatami, sino que también desarrollen carácter, control y mentalidad estratégica, valores fundamentales que acompañan el camino del Jiu-Jitsu.
                </p>
        </div>
    );
};

export default About;
